import React from "react";

import { ElementState, Preview } from "@creatomate/preview";

import ReplaceMedia from "./ReplaceMedia";
import MediaFields from "./MediaFields";

interface MediaContentProps {
  activeElement: ElementState;
  preview: Preview;
  handleMediaUploaded: (modifications: Record<string, any>) => {};
  handleUploadingValue: (value: boolean) => void;
  uploading: boolean;
}

const MediaContent = ({
  activeElement,
  handleMediaUploaded,
  handleUploadingValue,
  preview,
  uploading
}: MediaContentProps) => (
  <div className="FieldsContainer">
    <ReplaceMedia
      element={activeElement}
      handleMediaUploaded={handleMediaUploaded}
      onUploading={handleUploadingValue}
      preview={preview}
      uploading={uploading}
    />
    <MediaFields
      activeElement={activeElement}
      preview={preview}
    />
  </div>
);

export default MediaContent;
